const doc = [({"en":({"adminLabelHotelWaitingList":({"date":"Date", "email":"Email", "hotelPlanName":"Plan name", "hotelRoomName":"Room type name", "status":"Status"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;